import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchDevices(ctx, queryParams) {

            return new Promise((resolve, reject) => {
                axios
                    //.get('/apps/device/devices', { params: queryParams })
                    .get(`/api/v1/device/search?Search=${queryParams.q}&Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchAllDevices(ctx, queryParams) {
            const baseUrl = '/api/v1/device/searchall';
            const urlParams = new URLSearchParams();

            urlParams.append('Search', queryParams.q);
            urlParams.append('Page', queryParams.page);
            urlParams.append('PerPage', queryParams.perPage);

            if (queryParams.ownerId) {
                urlParams.append('OwnerId', queryParams.ownerId);
            }

            const url = `${baseUrl}?${urlParams.toString()}`;

            return new Promise((resolve, reject) => {
                axios
                    .get(url)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchDevice(ctx, {id}) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/device/devices/${id}`)
                    .get(`/api/v1/device?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addDevice(ctx, deviceData) {
            return new Promise((resolve, reject) => {
                let device = deviceData.deviceData
                axios
                    //.post('/apps/device/devices', { device: deviceData })
                    .post('/api/v1/Device', device)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addBulk(ctx, deviceData) {
            return new Promise((resolve, reject) => {
                let device = deviceData.deviceData
                axios
                    //.post('/apps/device/devices', { device: deviceData })
                    .post('/api/v1/Device/createdevicebulk', device)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateDevice(ctx, deviceData) {
            return new Promise((resolve, reject) => {
                let device = deviceData.deviceData
                axios
                    //.post('/apps/device/devices', { device: deviceData })
                    .put('/api/v1/Device', device)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchMobileOperators(ctx,) {

            return new Promise((resolve, reject) => {

                axios
                    //.get('/apps/asset/assets', { params: queryParams })
                    .get(`/api/v1/Device/searchmobileoperator?Page=1&PerPage=10`)
                    ///api/v1/Asset/searchmanufacturer?Page=1&PerPage=10
                    //.get(`/api/v1/Asset/search?Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchMobileProviders(ctx,) {

            return new Promise((resolve, reject) => {

                axios
                    //.get('/apps/asset/assets', { params: queryParams })
                    .get(`/api/v1/Device/searchmobileoperatorprovider?Page=1&PerPage=10`)
                    ///api/v1/Asset/searchmanufacturer?Page=1&PerPage=10
                    //.get(`/api/v1/Asset/search?Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchDeviceModel(ctx,) {

            return new Promise((resolve, reject) => {

                axios
                    //.get('/apps/asset/assets', { params: queryParams })
                    .get(`/api/v1/Device/searchdevicemodel?Page=1&PerPage=50`)
                    ///api/v1/Asset/searchmanufacturer?Page=1&PerPage=10
                    //.get(`/api/v1/Asset/search?Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchSimCard(ctx, queryParams) {

            return new Promise((resolve, reject) => {

                axios
                    //.get('/apps/asset/assets', { params: queryParams })
                    .get(`/api/v1/Device/searchsimcard?Search=${queryParams.q}&Page=1&PerPage=5`)
                    //.get(`/api/v1/Asset/search?Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchAssets(ctx, queryParams) {

            return new Promise((resolve, reject) => {

                axios
                    .get(`/api/v1/Asset/searchtoinstall?Search=${queryParams.q}&Page=1&PerPage=10`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        installDevice(ctx, deviceData) {
            return new Promise((resolve, reject) => {
                let device = deviceData.deviceData
                axios
                    //.post('/apps/device/devices', { device: deviceData })
                    .post('/api/v1/Device/InstallDevice', device)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        uninstallDevice(ctx, deviceData) {
            return new Promise((resolve, reject) => {
                let device = deviceData.deviceData
                axios
                    //.post('/apps/device/devices', { device: deviceData })
                    .post('/api/v1/Device/DeinstallDevice', device)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchProvider(ctx, {number}) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/device/devices/${id}`)
                    .get(`/api/v1/Device/GetSimCard?number=${number}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteDevice(ctx, {id}) {
            return new Promise((resolve, reject) => {

                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .delete(`/api/v1/Device?Id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchDeviceInstallations(ctx, { deviceId, customerId, startDate, endDate, page = 1, perPage = 100 }) {

            const urlParams = new URLSearchParams();
            if (deviceId) urlParams.append('deviceId', deviceId);
            if (customerId) urlParams.append('customerId', customerId);
            if (startDate) urlParams.append('startDate', startDate);
            if (endDate) urlParams.append('endDate', endDate);
            urlParams.append('page', page);
            urlParams.append('perPage', perPage);
            
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/device/searchdeviceinstallations?${urlParams.toString()}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchDeviceInstallationsExcel(ctx, { deviceId, customerId, startDate, endDate }) {
            const params = {};
            if (deviceId) params.deviceId = deviceId;
            if (customerId) params.customerId = customerId;
            if (startDate) params.startDate = startDate;
            if (endDate) params.endDate = endDate;

            return new Promise((resolve, reject) => {
                axios
                    .get('/api/v1/Device/ExportDeviceInstallationsExcel', {
                        params: params,
                        responseType: 'blob'
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },

        fetchCustomers(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Customer/search?Search=${queryParams.q}&Page=1&PerPage=10`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        
        // /api/v1/Telemetry/ForceTelemetryParameter
        forceTelemetry(ctx, forceTelemetryData) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/v1/Telemetry/ForceTelemetryParameter', forceTelemetryData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

    },

    //
}
